export const Svg_106 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M5.834 58.333V45.718h12.614v12.615H5.834Zm16.99 0V45.718h41.343v12.615H22.823Zm-16.99-16.99V28.656h12.614v12.687H5.834Zm16.99 0V28.656h41.343v12.687H22.823ZM5.833 24.281V11.666h12.614v12.615H5.834Zm16.99 0V11.666h41.343v12.615H22.823Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.323}
        x2={39.015}
        y1={18.666}
        y2={58.504}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)